<div id='nsed-logo'>
    <img src='./assets/images/logo_nsed.png' alt/>
</div>

<style type='text/scss'>
    #nsed-logo {
        width: 30%;
        height: fit-content;
        position: relative;
        padding-left: 3%;

        img {
            width: 100%;
        }
    }

	@media screen and (min-width:550px){
        #nsed-logo {
            width: 100%;
            max-height: 22vh;
            height: 22vh;

            img {
                height: 100%;
                object-fit: contain;
                object-position: top;
            }
        }
    }
</style>